module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABE0lEQVR42mNgGIrg//oWs//rW+v/b2ibCKaBfFT5ZgeIeFs/mF7XZk9lB4At/w/HQD4p8uRbvKFJF+qzC6gWAPkg8bUNMhAHtJWhyG9oaaeNz9Hx+tZ8qLp8qoYA3OcbWi+iGfwXjX8AEkKt26jrAEI+J4TJdQBOn29o+0eATyUHUOpzch1Ags+JdEBb2cD4nNQQoLrPEfgE2Nw1rXr09TmxIfF/bYsdtNx+hDefk24hejnxCGwP0D76+pxQSPxf1+wBdtm61g5oGthHXUuB5oFrRZD5IHuaPQZnLkDkhtZyKodA+dAoB0YdMOqAUQeMOgBREra0U7ckJLFfMPAhAOzLQRwBDAlIO588DNNP7b7hsAIAyuUuRzDJhJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/captadas_uni_sin.png
// module id = 5xnt
// module chunks = 0